import { Link } from "react-router-dom";
import TkBorder from "../../components/atoms/TkBorder";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepper = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "①「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodSupportRelatives",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodNoSupportRelatives",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    title: "④内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodSupportWithoutFormalMarriage",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    title: "⑤職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certificateOfResidence",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    title: "⑥その他、事実上の配偶者であることを証明する書類",
    keyword: "lawfulPartner",
    requiredIcon: true,
    type: "fileUpload",
    showLine: false,
  },
  {
    keyword: "text1",
    type: "lineTitle",
    lineTitle:
      "また、以下書類については、アップロードではなく、福祉医療機構へ郵送してください。",
  },
  {
    keyword: "textMailing",
    type: "lineTitle",
    lineTitle: <></>,
  },
  {
    keyword: "text2",
    type: "lineTitle",
    lineTitle: (
      <>
        同順位の遺族が２人以上いる場合は、同順位の遺族の中から代表者を定め、その者が請求者となる「退職手当金請求書」を作成します。
        <br />
        他の者は、代表者（請求者）に対して、退職手当金の請求及び受領の権限を委任する「委任状」（事務取扱要領様式１２号）を作成し、郵送してください。
      </>
    ),
  },
  {
    keyword: "textLinks",
    type: "lineTitle",
    lineTitle: (
      <>
        <Link
          className="link"
          target="_blank"
          to={"https://www.wam.go.jp/hp/wp-content/uploads/ininzyou31.pdf"}
        >
          ・代表者請求における委任状をダウンロード
        </Link>
        <br />
        <Link
          className="link"
          target="_blank"
          to={"https://www.wam.go.jp/hp/wp-content/uploads/kisai31ininzyou.pdf"}
        >
          ・委任状の記載例
        </Link>
      </>
    ),
  },
  {
    keyword: "textDocument",
    type: "lineTitle",
    lineTitle: (
      <>
        必要書類に戸籍謄本又は委任状が含まれる場合には、以下に郵送してください。
        <br />
        <TkBorder>
          【郵送先】〒105－8486 <br />
          　　　　　東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階
          <br />
          　　　　　独立行政法人福祉医療機構　共済部退職給付課　宛
        </TkBorder>
      </>
    ),
  },
];

const schema: any = {};

export { stepper, fakeTableList, schema };
